import { render, staticRenderFns } from "./view-form-submission.vue?vue&type=template&id=597d8b56"
import script from "./view-form-submission.vue?vue&type=script&lang=js"
export * from "./view-form-submission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports